module.exports = __webpack_public_path__ + "img/reflection_2.44f11e58.png";